import { render, staticRenderFns } from "./SalesByVendors.vue?vue&type=template&id=038851a5"
import script from "./SalesByVendors.vue?vue&type=script&lang=js"
export * from "./SalesByVendors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports